<div class="avatar {{size}}" [matTooltip]="tooltip"  [matTooltipPosition]="tooltipPosition">
  @if (!icon) {
    @if (!image) {
      <span [ngClass]="avatarClass" [style.background]="background || null">{{initials}}</span>
    }
    @if (image) {
      <img src="{{image}}" alt="" (error)="image = ''">
    }
  }
  @if (icon) {
    <span [ngClass]="avatarClass"><i class="material-icons">{{icon}}</i></span>
  }

  @if (badge) {
    <div class="badge material-icons text-{{badgeColor}}">{{badge}}</div>
  }

</div>
